module.exports = __webpack_public_path__ + "static/media/office.2e8f5665.png";